module.exports = __webpack_public_path__ + "static/media/banner-5.34fb18ec.jpg";